export default "__VITE_ASSET__CyGkqT5$__"